<section>
    <div class="rum-container grid">
        <div class="col-1 md:col-2 lg:col-3 xl:col-3"></div>
        <div class="col-10 md:col-8 lg:col-6 xl:col-6">
            <ng-content></ng-content>
        </div>
        <div class="col-1 md:col-2 lg:col-3 xl:col-3"></div>
    </div>
</section>